import React from "react";
import { IResourceComponentsProps, useShow } from "@refinedev/core";
import Cw8Show from "components/cw8/Cw8Show";
import { AntdShowInferencer } from "@refinedev/inferencer/antd";

export const CopyRightsShow: React.FC<IResourceComponentsProps> = () => {

    const resourceName :string = 'copyRight';
    return (
        <Cw8Show
            resourceName = {resourceName}
        ></Cw8Show>
    );   
};